import { gql } from "@apollo/client"

export const DeleteClient = gql`
mutation DeleteClient($deleteClientId: ID!) {
  deleteClient(id: $deleteClientId) {
    status
  }
}
`